angular.module('impactx.cscontract').controller('CSContractMainDataCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'ToolbarService',
    'PartialDialogsService',
    'ConfirmationService',
    CSContractMainDataCtrl
]);

function CSContractMainDataCtrl($scope, dataGen, $routeParams, ToastService, BackService, ToolbarService, PartialDialogsService, ConfirmationService) {
    var self = this;

    self.save = function ($event) {
        return dataGen.postAsForm($scope, {mainData: $scope.data}, "/cscontract/save").then(function (data) {
            ToastService.openStandardToastAfterSaveSuccess($scope, data);
            if(data && data.data && data.data.id) {
                var cscId = data.data.id;
                PartialDialogsService.addNew(PartialDialogsService.TYPE.CONTRACT, Number($routeParams.id), cscId);
                PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, cscId, 'cscmain', $routeParams.preSetId ? $routeParams.preSetId : 0);
            }
            else {
                BackService.back();
            }
        });
    };

    if ($routeParams.id > 0) {
        dataGen.getData($scope, {cscId: $routeParams.id}, "/cscontract/view").then(function () {
            defineButtons();
        })
    }
    else {
        dataGen.getData($scope, {
            type: $routeParams.type,
            buyerComId: $routeParams.buyerComId,
            supplierComId: $routeParams.supplierComId,
            contactBuyerId: $routeParams.contactBuyerId,
            catalogId: $routeParams.catalogId,
            masterContractId: $routeParams.masterContractId,
            isModelContract: $routeParams.isModelContract
        }, "/cscontract/new").then(function () {
            defineButtons();
        })
    }

    self.getBuyerContactEntries = function (searchText) {
        return dataGen.getData({}, {buyerCompanyId: $scope.data.buyerCompany.selected.id, searchText: searchText},
            "/cscontract/companyselection/buyercontact", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    self.getSupplierContactEntries = function (searchText) {
        return dataGen.getData({}, {supplierCompanyId: $scope.data.supplierCompany.selected.id, searchText: searchText},
            "/cscontract/companyselection/suppliercontact", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    self.getCatalogEntries = function (searchText) {
        return dataGen.getData({}, {supplierCompanyId: $scope.data.supplierCompany.selected.id, searchText: searchText},
            "/cscontract/companyselection/catalog", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    self.catalogChange = function (selected) {
        if ($scope.data.priceGroup) {
            dataGen.getData({}, {
                    catId: selected ? selected.id : 0, supplierId: $scope.data.supplierCompany.selected.id, setMatchCode:
                        $scope.data.priceGroup.selected ? $scope.data.priceGroup.selected.id : null
                },
                "/cscontract/pricegroup", null, true).then(function (data) {
                if (data.data.entries) {
                    $scope.data.priceGroup.hidden = false;
                    $scope.data.priceGroup = data.data;
                }
                else {
                    $scope.data.priceGroup.hidden = true;
                }
                self.updateSecondPriceGroup(selected ? selected.id : 0);
            });

        }
    };

    self.updateSecondPriceGroup = function (catId) {
        dataGen.getData({}, {
                contractType: $scope.data.contractType.selected.id,
                firstPriceGroup: $scope.data.priceGroup.selected ? $scope.data.priceGroup.selected.id : null,
                catId: catId,
                contractId: $scope.data.id,
                resaleCSCId: $scope.data.masterContract && $scope.data.masterContract.selected ? $scope.data.masterContract.selected.id : 0,
                supplierId: $scope.data.supplierCompany.selected.id,
                setMatchCode: $scope.data.secondPriceGroup && $scope.data.secondPriceGroup.selected ? $scope.data.secondPriceGroup.selected.id : null
            },
            "/cscontract/secondpricegroup", null, true).then(function (data) {
            var wasHidden = $scope.data.secondPriceGroup && $scope.data.secondPriceGroup.hidden;
            if (!data.data.secondPriceGroup && $scope.data.secondPriceGroup) {
                $scope.data.secondPriceGroup.hidden = true;
            }
            else {
                $scope.data.secondPriceGroup = data.data.secondPriceGroup;
            }
        });
    };

    this.delete = function() {
        var temp = {};
        dataGen.postAsForm(temp, {cscId: $scope.data.id}, "/cscontract/delete").then(function() {
            BackService.back();
            ToastService.openStandardToast(temp.trns.deleteSuccess);
        });
    };

    this.deleteDialog = function(event, trns) {
        ConfirmationService.showConfirmationDialog(self.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.canDelete = function () {
        return !$scope.data.isMDM && !$scope.data.isDeleted;
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteDialog,
                condition: self.canDelete,
                process: 'EditCSC'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}